"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowBusyException = exports.FLOW_BUSY = void 0;
const api_exceptions_1 = require("./api_exceptions");
/** The errorCode of a flow change given up because another change of the same flow held the flow-change lock too long. */
exports.FLOW_BUSY = "FLOW_BUSY";
/**
 * A change of a flow's steps or status given up, nothing changed, because it waited FLOW_CHANGE_WAIT for the flow-change
 * lock (IntegrationRepo.lockFlowChange) and another change still held it. Trying again shortly makes it. The API answers
 * 409 with errorCode FLOW_BUSY; the flow tools (FlowEditor) say it in words, as they say every other refusal.
 */
class FlowBusyException extends api_exceptions_1.ConflictException {
    constructor(flowId) {
        super("This flow is being changed or switched on or off by something else right now (for example by an AI agent, or in another tab), so this change was not made. Try again in a few seconds.", {
            errorCode: exports.FLOW_BUSY,
            shouldLog: false,
            publicData: { flowId: Number(flowId) },
        });
    }
}
exports.FlowBusyException = FlowBusyException;
//# sourceMappingURL=flow_busy_exception.js.map